// import * as dotenv from "dotenv";
// dotenv.config();

export abstract class AppConfig {
    static readonly API_ENDPOINT = "/api/v1";
    static readonly LOCAL_HOST = "http://localhost:3000";
    // static readonly DEV_SERVER = "http://ec2-52-66-s169-86.ap-south-1.compute.amazonaws.com:3000/api/v1/admin";
    static readonly DEV_SERVER = "https://yows.in/api/v1/admin";
    // static readonly DEV_SERVER = "/api/v1/admin";

    static readonly RAZORPAY_KEY_ID = "rzp_test_BsMt3tRUhxOhXj";
    static readonly RAZORPAY_KEY_SECRET = "Wb2JSIPqVZIbOEhvx8t2ckYB";
}